import { ActionKeys } from '~/actions/constants';
import * as WebhooksActions from '~/actions/webhooks.actions';
import { call, takeLatest } from 'redux-saga/effects';
import * as webhooksService from '~/services/webhooks.service';
import { WebhookAPIType } from '~/types/Webhooks';
import { camelizeKeys, decamelizeKeys } from '~/utils/humps';

export function* editWebhook(action: ReturnType<typeof WebhooksActions.editWebhook>) {
  try {
    const response = yield call(
      webhooksService.editWebhook,
      decamelizeKeys(action.payload.webhook) as WebhookAPIType,
    );
    action.callback(camelizeKeys(response.data));
  } catch (err) {
    action.callback({ error: err });
  }
}

export function* deleteWebhook(action: ReturnType<typeof WebhooksActions.deleteWebhook>) {
  try {
    const response = yield call(
      webhooksService.deleteWebhook,
      decamelizeKeys(action.payload.webhook) as WebhookAPIType,
    );
    action.callback(response);
  } catch (err) {
    action.callback({ error: err });
  }
}

export function* saveWebhook(action: ReturnType<typeof WebhooksActions.saveWebhook>) {
  try {
    const response = yield call(
      webhooksService.saveWebhook,
      decamelizeKeys(action.payload.webhook) as WebhookAPIType,
    );
    action.callback(camelizeKeys(response.data));
  } catch (err) {
    action.callback({ error: err });
  }
}

export function* testWebhook(action: ReturnType<typeof WebhooksActions.testWebhook>) {
  try {
    yield call(
      webhooksService.testWebhook,
      decamelizeKeys(action.payload.webhook) as WebhookAPIType,
    );
    action.callback(false);
  } catch (err) {
    action.callback(err);
  }
}

export function* getWebhooks(action: ReturnType<typeof WebhooksActions.getWebhooks>) {
  try {
    const response = yield call(webhooksService.getWebhooks);
    action.callback(camelizeKeys(response.data.results));
  } catch (err) {
    action.callback(err);
  }
}

export default [
  takeLatest(ActionKeys.FETCH_WEBHOOKS, getWebhooks),
  takeLatest(ActionKeys.EDIT_WEBHOOK, editWebhook),
  takeLatest(ActionKeys.SAVE_WEBHOOK, saveWebhook),
  takeLatest(ActionKeys.DELETE_WEBHOOK, deleteWebhook),
  takeLatest(ActionKeys.TEST_WEBHOOK, testWebhook),
];
